import { render } from "./AddCarBrandCondition.vue?vue&type=template&id=1b8a4b84&ts=true"
import script from "./AddCarBrandCondition.vue?vue&type=script&lang=ts"
export * from "./AddCarBrandCondition.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__